import React from 'react'
import { Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'

import * as CSS from './styles'

export function ResourcesTitleTooltipHint() {
  const { t } = useTranslation()

  return (
    <Tooltip
      title={
        <div>
          <span>{t('web.policies.rules.hint.resources-message1')}</span>
          <br />
          <br />
          <span>
            {t('common.enabled')}
            {': '}
            {t('web.policies.rules.hint.resources-message2')}
          </span>
          <br />
          <br />
          <span>
            {t('common.disabled')}
            {': '}
            {t('web.policies.rules.hint.resources-message3')}
          </span>
        </div>
      }
    >
      <CSS.Icon theme="twoTone" twoToneColor="#1890ff" type="info-circle" />
    </Tooltip>
  )
}
